import common from './common'
import Vue from 'vue'

export default {
  setAvailableOrganizations(state, payload) {
    state.availableOrganizations = payload
  },
  clearAvailableOrganizations(state) {
    state.availableOrganizations = null
  },

  addUsers(state, payload) {
    if (!payload) { return }
    let users = state.users
    if ( Array.isArray(payload) ) {
      payload.forEach(el => {
        if ( !users.some(it => el?.id == it?.id) ) {
          state.users.push(el)
        }
      })
    } else
      if ( !users.find(el => el ? el.id == payload.id : false)) {
        state.users.push(payload)
      }
  },

  editUser(state, payload) {
    let result = common._returnIndexById(state.users, payload?.id)
    if (state.users[result.returned]) {
      state.users[result.returned].avatar = payload.avatar
    } else {
      state.users.push(payload)
    }
  },

  setMyUser(state, payload) {
    state.my_user = payload
  },
  setCurrentOrganization(state, payload) {
    if (process.env.NODE_ENV !== 'development') {
      Vue.prototype.$sentry.setExtra('currentOrganization', state.payload)
    }
    sessionStorage.OrganizationItId = payload?.organizationItId
    state.currentOrganization = payload
  },
  setPersonalManagerContacts(state, payload) {
    state.personal_manager = payload
  },
  changeOrganisation(state, payload) {
    state.changeOrganisation = payload
  },
  setPersonalTimeZone(state, payload) {
    state.personalTimeZone = payload
  },
  setAvailableOrganizationsForCurrently(state, payload) {
    state.availableOrganizationsForCurrently = payload
  },
}
